import React from 'react'
import '../style.css'

const AboutUs2 = () => {
    return (
        <div className='aboutus-section aboutus-section-rev'>
            <div className='aboutus-content'>
                <h1 className='aboutus-h1'>Mission and Vision</h1>
                    <div className='aboutus-para-div'>
                    <p className='aboutus-para-2'>At Supramax Global, our mission is to deliver high-quality, innovative, and future-ready copper and fiber connectivity solutions that empower global communication networks. We are committed to supporting the digital infrastructure of businesses, data centers, and telecom providers by offering reliable products, technical expertise, and customer-focused service.

</p>

                    <p className='aboutus-para-2'>Our vision is to become a world leader in structured cabling and network infrastructure—recognized for our dedication to quality, sustainability, and technological advancement. We strive to build a more connected future by setting new standards in performance, reliability, and global accessibility.

</p>

                    {/* <p className='aboutus-para-2'>"To attain market leadership through unmatched quality, a diverse and unique product mix, empowered employees, world-class systems, and the highest ethical and professional standards."</p> */}

                    {/* <p className='aboutus-para-2'>"Superamax is devoted to achieve consistent improvement in the system of providing products & services to the customers through On Time Delivery & Enhancing Customers Satisfaction by means of Quality and Value."</p> */}
                    </div>
                {/* <button className='solid-button'>View All</button> */}
            </div>

            <div className='aboutus-img-div'>
                <img className='aboutus-img' src="/img/about2.png" alt="" />
            </div>
        </div>
    )
}

export default AboutUs2
